import { forwardRef } from "react";
import { Icon, type LucideProps } from "lucide-react";
import { tennisRacket } from "@lucide/lab";

export const TennisIcon = forwardRef<SVGSVGElement, LucideProps>(
  ({ className, ...props }, ref) => (
    <Icon ref={ref} iconNode={tennisRacket} className={className} {...props} />
  ),
);
TennisIcon.displayName = "TennisIcon";
